import { siteContent } from "@/data/siteContent";

export const FounderSection = () => {
  const { founder } = siteContent;

  return (
    <section id="founder" className="section-shell section-shell--teal founder-section" aria-labelledby="founder-title" data-testid="founder-section">
      <div className="site-container founder-copy-only">
        <p className="section-kicker" data-testid="founder-kicker">{founder.kicker}</p>
        <h2 id="founder-title" className="section-title" data-testid="founder-title">{founder.heading}</h2>
        <div className="founder-body" data-testid="founder-copy">
          {founder.copy.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </div>
      </div>
    </section>
  );
};